export const tickets = {
  detail: {
    _id: "67ecdc3c617b35c46208072a",
    tagTeam: [],
    tags: [],
    isSurveySent: false,
    isAiChat: true,
    entity: "653893232bd756be9bc2c452",
    userWallet: "654dac0d1a70eec88a93139f",
    user: {
      id: "654dac0dd8e379834a15ddd5",
      portalUserId: "654dac0dd8e379834a15ddd5",
      entityId: "653893232bd756be9bc2c452",
      status: "active",
      country: null,
      os: null,
      device: null,
      browser: null,
      data: {
        importedCsvFields: [],
        importedSmartContracts: [],
      },
      userSourceType: "websiteTraffic",
      userSourceDate: "2025-01-06T10:34:56.628Z",
      lastEngagementType: "ticketChat",
      lastEngagementDate: "2025-04-02T06:42:04.648Z",
      createdAt: "2023-11-10T04:05:33.889Z",
      updatedAt: "2025-05-15T09:16:55.623Z",
      deletedAt: null,
      addresses: [
        {
          status: "verified",
          walletId: "68373ec57a939d1fbce8598c",
          ecosystem: "evm",
          walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
        },
      ],
      externalAccounts: [],
      _id: "654dac0dd8e379834a15ddd5",
    },
    type: {
      _id: "67ec12041a59910df3cad2cd",
      readonly: true,
      entity: "653893232bd756be9bc2c452",
      name: "Other",
      index: 7,
      __v: 0,
    },
    title: "I cannot withdraw my USDT",
    description:
      "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
    status: "New",
    source: "widget",
    widgetConfig: {
      _id: "66c81a6b5fb810015d68acaa",
      name: "dApp Widget",
    },
    sourceName: "dApp Widget",
    hasNewMessage: true,
    created: "2025-04-02T06:42:04.522Z",
    lastUserResponse: "2025-04-02T06:42:04.522Z",
    noticeDate: null,
    autoCloseDate: null,
    __v: 0,
    groups: [
      {
        _id: "66ebabac5924d586b26130c1",
        name: "sdsdfsdfds",
      },
      {
        _id: "67d0ff2516f78c59a3839281",
        name: "Test",
      },
    ],
  },
  list: [
    {
      _id: "66c81c113fca890388d73799",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      isAiChat: true,
      entity: "66c8189a5fb810015d64d11e",
      userWallet: {
        _id: "66c81e7b592cb9a4e42aef4c",
        address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      },
      user: "66c81e7b592cb9a4e42aef5c",
      type: {
        _id: "66c81c4c592cb9a4e42991eb",
        name: "dLP & Locking",
      },
      title: "I cannot withdraw my USDT",
      description:
        "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
      status: "New",
      hasNewMessage: true,
      created: "2024-12-19T15:32:00.548Z",
      __v: 0,
      source: "widget",
      ongoingTime: null,
      widgetConfig: {
        _id: "66c81a6b5fb810015d68acaa",
        name: "dApp Widget",
      },
      sourceName: "dApp Widget",
    },
    {
      _id: "66c81c113fca890388d73798",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      userWallet: {
        _id: "66c81e7b592cb9a4e42aef4c",
        address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      },
      user: "66c81e7b592cb9a4e42aef5c",
      type: {
        _id: "66c81c4c592cb9a4e42991da",
        name: "General Help",
      },
      title: "I want to become a mod for Radiant Capital",
      description: "Do you have any job opening??",
      status: "Done",
      hasNewMessage: false,
      created: "2024-12-19T15:31:42.537Z",
      __v: 0,
      team: {
        _id: "65807639f8cb06835c94a856",
        address: "0x9Ec346743B1db8729B590c27df61Df796C0E3254",
        entity: "65807639e63d945efa37a621",
        __v: 0,
        created: "2023-12-18T16:41:29.859Z",
        email: null,
        name: "MetaCRM Operation",
        role: "65dc742107682dc82c77a925",
        internal: true,
        latestLogin: "2024-11-01T06:29:17.245Z",
        telegram: "",
      },
      source: "dApp Widget",
      manualCloseDate: "2023-12-19T15:31:44.138Z",
      source: "widget",
      ongoingTime: null,
      widgetConfig: {
        _id: "66c81a6b5fb810015d68acaa",
        name: "dApp Widget",
      },
      sourceName: "dApp Widget",
    },
    {
      _id: "66c81c113fca890388d73797",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      userWallet: {
        _id: "66c81f15592cb9a4e42bb568",
        address: "0xdC1CAD9195f5EC858E9A00a62a454A53AB9eEF51",
      },
      user: "66c81f15592cb9a4e42bb576",
      type: {
        _id: "66c81c4c592cb9a4e42991eb",
        name: "dLP & Locking",
      },
      title: "I want to become a mod for Radiant Capital",
      description: "Do you have any job opening??",
      status: "Done",
      hasNewMessage: false,
      created: "2023-12-19T15:06:22.082Z",
      __v: 0,
      team: {
        _id: "65807639f8cb06835c94a856",
        address: "0x9Ec346743B1db8729B590c27df61Df796C0E3254",
        entity: "65807639e63d945efa37a621",
        __v: 0,
        created: "2023-12-18T16:41:29.859Z",
        email: null,
        name: "MetaCRM Operation",
        role: "65dc742107682dc82c77a925",
        internal: true,
        latestLogin: "2024-11-01T06:29:17.245Z",
        telegram: "",
      },
      source: "dApp Widget",
      manualCloseDate: "2023-12-19T15:06:23.546Z",
      ongoingTime: null,
      source: "widget",
      ongoingTime: null,
      widgetConfig: {
        _id: "66c81a6b5fb810015d68acaa",
        name: "dApp Widget",
      },
      sourceName: "dApp Widget",
    },
    {
      _id: "66c81c113fca890388d73796",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      userWallet: {
        _id: "66c81f15592cb9a4e42bb568",
        address: "0xdC1CAD9195f5EC858E9A00a62a454A53AB9eEF51",
      },
      user: "66c81f15592cb9a4e42bb576",
      type: {
        _id: "66c81c4c592cb9a4e42991da",
        name: "General Help",
      },
      title: "I cannot withdraw my USDT",
      description:
        "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
      status: "Done",
      hasNewMessage: true,
      created: "2023-12-19T15:05:18.021Z",
      __v: 0,
      source: "supportCenter",
      manualCloseDate: "2023-12-19T15:05:20.948Z",
      ongoingTime: null,
      source: "widget",
      ongoingTime: null,
      widgetConfig: {
        _id: "66c81a6b5fb810015d68acaa",
        name: "dApp Widget",
      },
      sourceName: "dApp Widget",
    },
    {
      _id: "66c81c113fca890388d73790",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      title: "Withdrawing DLP and breaking up the assets",
      user: "66c81e7b592cb9a4e42aef30",
      userWallet: {
        _id: "66c81e7b592cb9a4e42aef23",
        address: "0x35C37AA99f9D95D96F700Af9Cfa20AEE8bC17178",
      },
      __v: 0,
      comment: "This is def an OG!",
      created: "2023-06-27T16:56:04.221Z",
      description:
        "Hi, I have some tokens locked in RDNT - WETH dlp at the moment. How do I redeem the assets and withdraw from Radiant Capital",
      hasNewMessage: false,
      status: "New",
      type: {
        _id: "66c81c4c592cb9a4e42991eb",
        name: "dLP & Locking",
      },
      source: "widget",
      ongoingTime: null,
      widgetConfig: {
        _id: "66c81a6b5fb810015d68acaa",
        name: "dApp Widget",
      },
      sourceName: "dApp Widget",
    },
    {
      _id: "66c81c113fca890388d73794",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      title: "Hi I'm a newbie",
      user: "66c81e7b592cb9a4e42aeef1",
      userWallet: {
        _id: "66c81e7b592cb9a4e42aeee0",
        address: "0xeee70fc4F25CD24e17e6664dD93C725A5aE6Aa58",
      },
      __v: 0,
      created: "2023-04-13T05:49:12.436Z",
      description: "Please teach me how to use this protocol",
      status: "New",
      type: {
        _id: "66c81c4c592cb9a4e42991da",
        name: "General Help",
      },
      source: "discord",
      ongoingTime: null,
      sourceName: null,
    },
    {
      _id: "66c81c113fca890388d73795",
      lastUserResponse: "2024-12-28T08:47:51.964Z",
      tagTeam: [],
      tags: [],
      isSurveySent: false,
      entity: "66c8189a5fb810015d64d11e",
      title: "Hi From Telegram",
      user: "66c81e7b592cb9a4e42aeef1",
      userWallet: {
        _id: "66c81e7b592cb9a4e42aeee0",
        address: "0xeee70fc4F25CD24e17e6664dD93C725A5aE6Aa58",
      },
      __v: 0,
      created: "2023-04-13T05:49:12.436Z",
      description: "Please teach me how to use this protocol",
      status: "New",
      type: {
        _id: "66c81c4c592cb9a4e42991da",
        name: "General Help",
      },
      source: "telegram",
      ongoingTime: null,
      sourceName: null,
    },
  ],

  messages: [
    {
      _id: "66c81c113fca890388d737a1",
      imagesUrl: [
        "https://storage.googleapis.com/metadesk-demo/chat/0x175fd9b68973c4b2a5f371909FB624b0aEb88Cc5/withdraw-1702999920.png",
      ],
      entity: "66c8189a5fb810015d64d11e",
      ticket: "66c81c113fca890388d73799",
      user: "66c81e7b592cb9a4e42aef5c",
      message:
        "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
      created: "2023-12-19T15:32:03.021Z",
      __v: 0,
    },
  ],
  aiConfig: {
    success: true,
    config: {
      aiConfig: {
        retryCount: 1,
        _id: "66c81a645fb810015d680fb8",
        entity: "66c8189a5fb810015d64d11e",
        __v: 0,
        createdAt: "2024-06-13T14:05:22.789Z",
        documentSyncStatus: "completed",
        documentType: "Gitbook",
        documentUrl: "https://docs.radiant.capital/radiant",
        pineconeIndex: "metacrm-pc-index-demo-1",
        updatedAt: "2024-06-18T17:22:24.701Z",
        pineconeNamespace: "65807639e63d945efa37a621",
      },
      magicWandConfig: {
        _id: "66c81a655fb810015d680fbd",
        entity: "66c8189a5fb810015d64d11e",
        tone: "Friendly",
        length: "Short",
        createdAt: "2024-06-13T14:17:15.500Z",
        updatedAt: "2024-06-13T14:17:56.926Z",
        __v: 0,
        fallbackMsg: "",
      },
    },
    serviceModuleConfig: {
      _id: "66c81a645fb810015d680fa9",
      discordWebhook: {
        enabled: true,
        connected: false,
      },
      widgetSupport: {
        isCustomizationAllowed: true,
        enabled: true,
      },
      aiSupport: {
        magicWand: {
          enabled: true,
          connected: true,
        },
        enabled: true,
        connected: true,
      },
      github: {
        connected: false,
        enabled: false,
      },
      discord: {
        connected: true,
        enabled: true,
        serverId: "1077605035153817741",
        serverName: "0xJFox's server",
        updatedAt: "2024-11-27T16:32:49.735Z",
      },
      slack: {
        connected: false,
        enabled: true,
      },
      mailchimp: {
        connected: false,
        enabled: true,
      },
      webSupport: {
        connected: true,
        enabled: true,
      },
      entity: "66c8189a5fb810015d64d11e",
      __v: 0,
      telegram: {
        connected: false,
        enabled: true,
        updatedAt: "2024-10-18T05:42:00.428Z",
      },
      discordAnalytics: {
        connected: false,
        enabled: false,
        updatedAt: "2024-11-27T16:32:49.735Z",
      },
      telegramAnalytics: {
        connected: false,
        enabled: false,
        updatedAt: "2024-11-27T16:32:49.735Z",
      },
    },
  },
  walletInfo: {
    _id: "66c81e7b592cb9a4e42aef4c",
    address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
    entity: "66c8189a5fb810015d64d11e",
    __v: 1,
    created: "2023-11-07T11:00:35.873Z",

    entitySpecificNFTInfoByChain: {},
    nftInfoByChain: {
      56: {
        _id: "66875ee17bafeb2a5c017d6b",
        nftAmount: 2,
        nftList: [
          {
            _id: "66875ee17bafeb2a5c017d6c",
            chain: "bsc",
            name: "@metacrm",
            amount: 1,
            address: "0x2723522702093601e6360cae665518c4f63e9da6",
            content:
              "https://static.debank.com/image/bsc_nft/local_url/f521587e705a1cea8c567452622b94b2/d2575437af7fb066a7e7f59be0ddcb15.svg",
          },
          {
            _id: "66875ee17bafeb2a5c017d6d",
            chain: "bsc",
            name: "metacrm.bnb",
            amount: 1,
            address: "0xe3b1d32e43ce8d658368e2cbff95d57ef39be8a6",
            content: "",
          },
        ],
        chainId: "56",
      },
      42161: {
        _id: "66875ee17bafeb2a5c017d6e",
        nftAmount: 1,
        nftList: [
          {
            _id: "66875ee17bafeb2a5c017d6f",
            chain: "arb",
            name: "metacrm.arb",
            amount: 1,
            address: "0x5d482d501b369f5ba034dec5c5fb7a50d2d6ca20",
            content:
              "https://static.debank.com/image/arb_nft/local_url/42cfd8c4a1d555b6bff7ce245b0f95c8/a171bf228b51157c60067f084bad7f69.svg",
          },
        ],
        chainId: "42161",
      },
    },
    protocols: [
      {
        id: "curve",
        chain: "eth",
        name: "Curve",
        site_url: "https://curve.fi",
        logo_url:
          "https://static.debank.com/image/project/logo_url/curve/aa991be165e771cff87ae61e2a61ef68.png",
        has_supported_portfolio: true,
        tvl: 2394904288.4085298,
        net_usd_value: 809.1744353832039,
        asset_usd_value: 809.1744353832039,
        debt_usd_value: 0,
      },
    ],
    updated: "2024-07-05T02:48:01.887Z",
    updatedList: [
      {
        _id: "654a18d422227f466fd16edf",
        chainId: 1,
        firstTransactionDate: "2023-01-04T03:18:11.000Z",
        latestTransactionDate: "2023-12-05T02:23:35.000Z",
        protocolDataFetching: false,
        onChainDataFetching: false,
        onChainDataUpdated: "2024-01-29T11:58:40.364Z",
        lastQueriedBlock: 19112036,
        nonce: 17,
        protocolDataUpdated: "2024-01-29T11:58:41.133Z",
      },
      {
        _id: "654a18d422227f466fd16ee0",
        chainId: 56,
        firstTransactionDate: "2022-10-25T08:28:36.000Z",
        latestTransactionDate: "2023-10-04T04:29:27.000Z",
        protocolDataFetching: false,
        onChainDataFetching: false,
        lastQueriedBlock: 35667646,
        nonce: 14,
        protocolDataUpdated: "2024-01-29T11:58:50.811Z",
        onChainDataUpdated: "2024-01-29T11:58:50.117Z",
      },
      {
        _id: "654a18d422227f466fd16ee1",
        chainId: 137,
        firstTransactionDate: "2022-12-12T10:41:14.000Z",
        latestTransactionDate: "2023-11-09T12:38:15.000Z",
        protocolDataFetching: false,
        onChainDataFetching: false,
        lastQueriedBlock: 50759428,
        nonce: 26,
        protocolDataUpdated: "2023-12-05T05:59:19.690Z",
        onChainDataUpdated: "2023-12-05T05:59:20.261Z",
      },
      {
        _id: "654a18d422227f466fd16ee2",
        chainId: 42161,
        firstTransactionDate: "2023-07-28T03:32:55.000Z",
        latestTransactionDate: "2023-10-17T09:59:59.000Z",
        protocolDataFetching: false,
        onChainDataFetching: false,
        lastQueriedBlock: 175375613,
        nonce: 3,
        protocolDataUpdated: "2024-01-29T11:58:45.675Z",
        onChainDataUpdated: "2024-01-29T11:58:44.711Z",
      },
      {
        _id: "656582ccc4fd0b0d45786bd8",
        chainId: 10,
        protocolDataFetching: false,
        onChainDataFetching: false,
        lastQueriedBlock: 113078584,
        nonce: 1,
        protocolDataUpdated: "2023-12-05T05:59:14.623Z",
        firstTransactionDate: "2023-10-17T10:51:51.000Z",
        latestTransactionDate: "2023-10-17T10:51:51.000Z",
        onChainDataUpdated: "2023-12-05T05:59:14.753Z",
      },
    ],
    walletInfoByChain: {
      1: {
        _id: "66875ee17bafeb2a5c017d70",
        chainId: "1",
        walletValue: 1790.368604427933,
        tokenList: [
          {
            _id: "66875ee17bafeb2a5c017d71",
            chain: "eth",
            name: "Curve DAO Token",
            symbol: "CRV",
            price: 0.6133,
            amount: 91.47032889252712,
            address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
          },
          {
            _id: "66875ee17bafeb2a5c017d72",
            chain: "eth",
            name: "Tether USD",
            symbol: "USDT",
            price: 1.000315,
            amount: 68.149684,
            address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
          },
          {
            _id: "66875ee17bafeb2a5c017d73",
            chain: "eth",
            name: "# eth-apy.com",
            symbol: "Visit https://eth-apy.com to claim rewards",
            price: 0,
            amount: 1.4,
            address: "0xf494eb47d29822b10b607299c5ff27a58bca6e0f",
          },
          {
            _id: "66875ee17bafeb2a5c017d74",
            chain: "eth",
            name: "ETH",
            symbol: "ETH",
            price: 2054.73,
            amount: 0.4176831178302928,
            address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
          },
        ],
      },
      56: {
        _id: "66875ee17bafeb2a5c017d75",
        chainId: "56",
        walletValue: 724.7220570141368,
        tokenList: [
          {
            _id: "66875ee17bafeb2a5c017d76",
            chain: "bsc",
            name: "Factr",
            symbol: "Factr",
            price: 0.016585614690562935,
            amount: 700000,
            address: "0x396d8805d184ef5325b5ccd107638adfd38ccff8",
          },
          {
            _id: "66875ee17bafeb2a5c017d77",
            chain: "bsc",
            name: "vSWAP.fi",
            symbol: "vBSWAP",
            price: 6.665856547748546,
            amount: 1e-12,
            address: "0x4f0ed527e8a95ecaa132af214dfd41f30b361600",
          },
          {
            _id: "66875ee17bafeb2a5c017d78",
            chain: "bsc",
            name: "Tether USD",
            symbol: "USDT",
            price: 1.000315,
            amount: 500.0005,
            address: "0x55d398326f99059ff775485246999027b3197955",
          },
          {
            _id: "66875ee17bafeb2a5c017d79",
            chain: "bsc",
            name: "eCash",
            symbol: "XEC",
            price: 0.00003631435245723672,
            amount: 29000000,
            address: "0x5f7a1a4dafd0718caee1184caa4862543f75edb1",
          },
          {
            _id: "66875ee17bafeb2a5c017d7a",
            chain: "bsc",
            name: "My Get Rich Token",
            symbol: "MGRT",
            price: 0.0056991262590739685,
            amount: 120000.576,
            address: "0x71753d0586ea6b979dfccbb492a45e611e0e0ad6",
          },
          {
            _id: "66875ee17bafeb2a5c017d7b",
            chain: "bsc",
            name: "AAL",
            symbol: "AAL",
            price: 0.6236958005122005,
            amount: 56000,
            address: "0x97eae24ca21fc9c0c5d4c31d12e9100ab50f20ea",
          },
          {
            _id: "66875ee17bafeb2a5c017d7c",
            chain: "bsc",
            name: "AI Avail",
            symbol: "AI-A",
            price: 0.2860583841646094,
            amount: 23000,
            address: "0xd048b4c23af828e5be412505a51a8dd7b37782dd",
          },
          {
            _id: "66875ee17bafeb2a5c017d7d",
            chain: "bsc",
            name: "BNB",
            symbol: "BNB",
            price: 252.8,
            amount: 0.8883071869328723,
            address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
          },
        ],
      },
      137: {
        _id: "66875ee17bafeb2a5c017d7e",
        chainId: "137",
        walletValue: 2.5762669593498777,
        tokenList: [
          {
            _id: "66875ee17bafeb2a5c017d7f",
            chain: "matic",
            name: "@ jmusd.xyz",
            symbol: "Visit https://jmusd.xyz to claim rewards",
            price: 0,
            amount: 562,
            address: "0x10a6f5f683b3d6b5cd90ffad9546284b1ca1938e",
          },
          {
            _id: "66875ee17bafeb2a5c017d80",
            chain: "matic",
            name: "$ jusdt.site",
            symbol: "Visit https://jusdt.site to claim reward",
            price: 0,
            amount: 812,
            address: "0x352bbc4a6c86942464b601ae9b54271dab114ec6",
          },
          {
            _id: "66875ee17bafeb2a5c017d81",
            chain: "matic",
            name: "AAVEPool.org",
            symbol: "AAVE",
            price: 0,
            amount: 59.29,
            address: "0x71c3f47a6e571da30084a984c430d2bb000cff74",
          },
          {
            _id: "66875ee17bafeb2a5c017d82",
            chain: "matic",
            name: "$ kusd.site",
            symbol: "Reward Token. Claim reward at https://kusd.site",
            price: 0,
            amount: 518,
            address: "0xa9000fe2aa7a6189bcd31e8131ab5ad12636a5d2",
          },
          {
            _id: "66875ee17bafeb2a5c017d83",
            chain: "matic",
            name: "MetaToken",
            symbol: "MT",
            price: 0,
            amount: 200,
            address: "0xbd6d86ad2fab81c6b5ce48e9e788884ec13019c9",
          },
          {
            _id: "66875ee17bafeb2a5c017d84",
            chain: "matic",
            name: "(PoS) Tether USD",
            symbol: "USDT",
            price: 1.000315,
            amount: 1.293585,
            address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
          },
          {
            _id: "66875ee17bafeb2a5c017d85",
            chain: "matic",
            name: "$ USDCpool.cloud",
            symbol: "Claim USDC/WETH at https://USDCpool.cloud",
            price: 0,
            amount: 959,
            address: "0xf2ca85b592247121cda7cfe3c3a0098fbce4a304",
          },
          {
            _id: "66875ee17bafeb2a5c017d86",
            chain: "matic",
            name: "MATIC",
            symbol: "MATIC",
            price: 0.929351,
            amount: 1.3797526231476347,
            address: "0x0000000000000000000000000000000000001010",
          },
        ],
      },
      42161: {
        _id: "66875ee17bafeb2a5c017d87",
        chainId: "42161",
        walletValue: 74.73672358811437,
        tokenList: [
          {
            _id: "66875ee17bafeb2a5c017d88",
            chain: "arb",
            name: "! Synth sUSD",
            symbol: "sUSD [Synthetix.cc]",
            price: 0,
            amount: 680,
            address: "0x68ce2acccc5620527cb47997b1e0aceb52ca48ec",
          },
          {
            _id: "66875ee17bafeb2a5c017d89",
            chain: "arb",
            name: "ETH",
            symbol: "ETH",
            price: 2054.73,
            amount: 0.03637301425886339,
            address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
          },
        ],
      },
    },
    entityTokenInfo: {},
    walletValue: 2592.403651989534,
    nftAmount: 3,
  },

  userInfo: {
    _id: "66c81e7b592cb9a4e42aef5c",
    addresses: [
      {
        _id: "66c81e7b592cb9a4e42aef4c",
        address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
        entity: "66c8189a5fb810015d64d11e",
        __v: 1,
        created: "2023-11-07T11:00:35.873Z",
        entitySpecificNFTInfoByChain: {},
        nftInfoByChain: {
          56: {
            _id: "66875ee17bafeb2a5c017d6b",
            nftAmount: 2,
            nftList: [
              {
                _id: "66875ee17bafeb2a5c017d6c",
                chain: "bsc",
                name: "@metacrm",
                amount: 1,
                address: "0x2723522702093601e6360cae665518c4f63e9da6",
                content:
                  "https://static.debank.com/image/bsc_nft/local_url/f521587e705a1cea8c567452622b94b2/d2575437af7fb066a7e7f59be0ddcb15.svg",
              },
              {
                _id: "66875ee17bafeb2a5c017d6d",
                chain: "bsc",
                name: "metacrm.bnb",
                amount: 1,
                address: "0xe3b1d32e43ce8d658368e2cbff95d57ef39be8a6",
                content: "",
              },
            ],
            chainId: "56",
          },
          42161: {
            _id: "66875ee17bafeb2a5c017d6e",
            nftAmount: 1,
            nftList: [
              {
                _id: "66875ee17bafeb2a5c017d6f",
                chain: "arb",
                name: "metacrm.arb",
                amount: 1,
                address: "0x5d482d501b369f5ba034dec5c5fb7a50d2d6ca20",
                content:
                  "https://static.debank.com/image/arb_nft/local_url/42cfd8c4a1d555b6bff7ce245b0f95c8/a171bf228b51157c60067f084bad7f69.svg",
              },
            ],
            chainId: "42161",
          },
        },
        protocols: [
          {
            id: "curve",
            chain: "eth",
            name: "Curve",
            site_url: "https://curve.fi",
            logo_url:
              "https://static.debank.com/image/project/logo_url/curve/aa991be165e771cff87ae61e2a61ef68.png",
            has_supported_portfolio: true,
            tvl: 2394904288.4085298,
            net_usd_value: 809.1744353832039,
            asset_usd_value: 809.1744353832039,
            debt_usd_value: 0,
          },
        ],
        updated: "2024-07-05T02:48:01.887Z",
        updatedList: [
          {
            _id: "654a18d422227f466fd16edf",
            chainId: 1,
            firstTransactionDate: "2023-01-04T03:18:11.000Z",
            latestTransactionDate: "2023-12-05T02:23:35.000Z",
            protocolDataFetching: false,
            onChainDataFetching: false,
            onChainDataUpdated: "2024-01-29T11:58:40.364Z",
            lastQueriedBlock: 19112036,
            nonce: 17,
            protocolDataUpdated: "2024-01-29T11:58:41.133Z",
          },
          {
            _id: "654a18d422227f466fd16ee0",
            chainId: 56,
            firstTransactionDate: "2022-10-25T08:28:36.000Z",
            latestTransactionDate: "2023-10-04T04:29:27.000Z",
            protocolDataFetching: false,
            onChainDataFetching: false,
            lastQueriedBlock: 35667646,
            nonce: 14,
            protocolDataUpdated: "2024-01-29T11:58:50.811Z",
            onChainDataUpdated: "2024-01-29T11:58:50.117Z",
          },
          {
            _id: "654a18d422227f466fd16ee1",
            chainId: 137,
            firstTransactionDate: "2022-12-12T10:41:14.000Z",
            latestTransactionDate: "2023-11-09T12:38:15.000Z",
            protocolDataFetching: false,
            onChainDataFetching: false,
            lastQueriedBlock: 50759428,
            nonce: 26,
            protocolDataUpdated: "2023-12-05T05:59:19.690Z",
            onChainDataUpdated: "2023-12-05T05:59:20.261Z",
          },
          {
            _id: "654a18d422227f466fd16ee2",
            chainId: 42161,
            firstTransactionDate: "2023-07-28T03:32:55.000Z",
            latestTransactionDate: "2023-10-17T09:59:59.000Z",
            protocolDataFetching: false,
            onChainDataFetching: false,
            lastQueriedBlock: 175375613,
            nonce: 3,
            protocolDataUpdated: "2024-01-29T11:58:45.675Z",
            onChainDataUpdated: "2024-01-29T11:58:44.711Z",
          },
          {
            _id: "656582ccc4fd0b0d45786bd8",
            chainId: 10,
            protocolDataFetching: false,
            onChainDataFetching: false,
            lastQueriedBlock: 113078584,
            nonce: 1,
            protocolDataUpdated: "2023-12-05T05:59:14.623Z",
            firstTransactionDate: "2023-10-17T10:51:51.000Z",
            latestTransactionDate: "2023-10-17T10:51:51.000Z",
            onChainDataUpdated: "2023-12-05T05:59:14.753Z",
          },
        ],
        walletInfoByChain: {
          1: {
            _id: "66875ee17bafeb2a5c017d70",
            chainId: "1",
            walletValue: 1790.368604427933,
            tokenList: [
              {
                _id: "66875ee17bafeb2a5c017d71",
                chain: "eth",
                name: "Curve DAO Token",
                symbol: "CRV",
                price: 0.6133,
                amount: 91.47032889252712,
                address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              },
              {
                _id: "66875ee17bafeb2a5c017d72",
                chain: "eth",
                name: "Tether USD",
                symbol: "USDT",
                price: 1.000315,
                amount: 68.149684,
                address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              },
              {
                _id: "66875ee17bafeb2a5c017d73",
                chain: "eth",
                name: "# eth-apy.com",
                symbol: "Visit https://eth-apy.com to claim rewards",
                price: 0,
                amount: 1.4,
                address: "0xf494eb47d29822b10b607299c5ff27a58bca6e0f",
              },
              {
                _id: "66875ee17bafeb2a5c017d74",
                chain: "eth",
                name: "ETH",
                symbol: "ETH",
                price: 2054.73,
                amount: 0.4176831178302928,
                address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              },
            ],
          },
          56: {
            _id: "66875ee17bafeb2a5c017d75",
            chainId: "56",
            walletValue: 724.7220570141368,
            tokenList: [
              {
                _id: "66875ee17bafeb2a5c017d76",
                chain: "bsc",
                name: "Factr",
                symbol: "Factr",
                price: 0.016585614690562935,
                amount: 700000,
                address: "0x396d8805d184ef5325b5ccd107638adfd38ccff8",
              },
              {
                _id: "66875ee17bafeb2a5c017d77",
                chain: "bsc",
                name: "vSWAP.fi",
                symbol: "vBSWAP",
                price: 6.665856547748546,
                amount: 1e-12,
                address: "0x4f0ed527e8a95ecaa132af214dfd41f30b361600",
              },
              {
                _id: "66875ee17bafeb2a5c017d78",
                chain: "bsc",
                name: "Tether USD",
                symbol: "USDT",
                price: 1.000315,
                amount: 500.0005,
                address: "0x55d398326f99059ff775485246999027b3197955",
              },
              {
                _id: "66875ee17bafeb2a5c017d79",
                chain: "bsc",
                name: "eCash",
                symbol: "XEC",
                price: 0.00003631435245723672,
                amount: 29000000,
                address: "0x5f7a1a4dafd0718caee1184caa4862543f75edb1",
              },
              {
                _id: "66875ee17bafeb2a5c017d7a",
                chain: "bsc",
                name: "My Get Rich Token",
                symbol: "MGRT",
                price: 0.0056991262590739685,
                amount: 120000.576,
                address: "0x71753d0586ea6b979dfccbb492a45e611e0e0ad6",
              },
              {
                _id: "66875ee17bafeb2a5c017d7b",
                chain: "bsc",
                name: "AAL",
                symbol: "AAL",
                price: 0.6236958005122005,
                amount: 56000,
                address: "0x97eae24ca21fc9c0c5d4c31d12e9100ab50f20ea",
              },
              {
                _id: "66875ee17bafeb2a5c017d7c",
                chain: "bsc",
                name: "AI Avail",
                symbol: "AI-A",
                price: 0.2860583841646094,
                amount: 23000,
                address: "0xd048b4c23af828e5be412505a51a8dd7b37782dd",
              },
              {
                _id: "66875ee17bafeb2a5c017d7d",
                chain: "bsc",
                name: "BNB",
                symbol: "BNB",
                price: 252.8,
                amount: 0.8883071869328723,
                address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              },
            ],
          },
          137: {
            _id: "66875ee17bafeb2a5c017d7e",
            chainId: "137",
            walletValue: 2.5762669593498777,
            tokenList: [
              {
                _id: "66875ee17bafeb2a5c017d7f",
                chain: "matic",
                name: "@ jmusd.xyz",
                symbol: "Visit https://jmusd.xyz to claim rewards",
                price: 0,
                amount: 562,
                address: "0x10a6f5f683b3d6b5cd90ffad9546284b1ca1938e",
              },
              {
                _id: "66875ee17bafeb2a5c017d80",
                chain: "matic",
                name: "$ jusdt.site",
                symbol: "Visit https://jusdt.site to claim reward",
                price: 0,
                amount: 812,
                address: "0x352bbc4a6c86942464b601ae9b54271dab114ec6",
              },
              {
                _id: "66875ee17bafeb2a5c017d81",
                chain: "matic",
                name: "AAVEPool.org",
                symbol: "AAVE",
                price: 0,
                amount: 59.29,
                address: "0x71c3f47a6e571da30084a984c430d2bb000cff74",
              },
              {
                _id: "66875ee17bafeb2a5c017d82",
                chain: "matic",
                name: "$ kusd.site",
                symbol: "Reward Token. Claim reward at https://kusd.site",
                price: 0,
                amount: 518,
                address: "0xa9000fe2aa7a6189bcd31e8131ab5ad12636a5d2",
              },
              {
                _id: "66875ee17bafeb2a5c017d83",
                chain: "matic",
                name: "MetaToken",
                symbol: "MT",
                price: 0,
                amount: 200,
                address: "0xbd6d86ad2fab81c6b5ce48e9e788884ec13019c9",
              },
              {
                _id: "66875ee17bafeb2a5c017d84",
                chain: "matic",
                name: "(PoS) Tether USD",
                symbol: "USDT",
                price: 1.000315,
                amount: 1.293585,
                address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
              },
              {
                _id: "66875ee17bafeb2a5c017d85",
                chain: "matic",
                name: "$ USDCpool.cloud",
                symbol: "Claim USDC/WETH at https://USDCpool.cloud",
                price: 0,
                amount: 959,
                address: "0xf2ca85b592247121cda7cfe3c3a0098fbce4a304",
              },
              {
                _id: "66875ee17bafeb2a5c017d86",
                chain: "matic",
                name: "MATIC",
                symbol: "MATIC",
                price: 0.929351,
                amount: 1.3797526231476347,
                address: "0x0000000000000000000000000000000000001010",
              },
            ],
          },
          42161: {
            _id: "66875ee17bafeb2a5c017d87",
            chainId: "42161",
            walletValue: 74.73672358811437,
            tokenList: [
              {
                _id: "66875ee17bafeb2a5c017d88",
                chain: "arb",
                name: "! Synth sUSD",
                symbol: "sUSD [Synthetix.cc]",
                price: 0,
                amount: 680,
                address: "0x68ce2acccc5620527cb47997b1e0aceb52ca48ec",
              },
              {
                _id: "66875ee17bafeb2a5c017d89",
                chain: "arb",
                name: "ETH",
                symbol: "ETH",
                price: 2054.73,
                amount: 0.03637301425886339,
                address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              },
            ],
          },
        },
      },
    ],
    entity: "66c8189a5fb810015d64d11e",
    __v: 1,
    created: "2023-11-09T10:17:12.622Z",
    discordIDs: [],
    email: "kevin@gmail.com",
    importedCsvFields: [
      "65b792d7c191227e4342db37",
      "65b792d7c191227e4342db45",
      "65b792d7c191227e4342db58",
      "65b792d7c191227e4342db6c",
      "65b792d7c191227e4342db7c",
      "65b792d7c191227e4342db87",
      "65b792d7c191227e4342db91",
    ],
    importedSmartContracts: [],
    lastEngagement: {
      type: "csvImport",
      date: "2024-01-29T11:58:23.769Z",
    },
    source: {
      _id: "66c818ab5fb810015d64f2d2",
      type: "contract",
      date: "2024-08-23T05:30:35.078Z",
    },
    sources: ["66c818ab5fb810015d64f2d2"],
    tags: [
      {
        _id: "65b1e6264adbeeadfaffe8df",
        entity: "65807639e63d945efa37a621",
        type: "user",
        value: "Random",
        color: "#D6BBFB",
        __v: 0,
      },
      {
        _id: "65b793db3cc27db6121a8a09",
        entity: "65807639e63d945efa37a621",
        type: "user",
        value: "MetaForm",
        color: "#FDA19B",
        __v: 0,
      },
      {
        _id: "65bbbc611a63ece21827aa31",
        entity: "65807639e63d945efa37a621",
        type: "user",
        value: "Bug Report",
        color: "#FEC84B",
        __v: 0,
      },
    ],
    twitterIDs: [],
    updated: "2024-02-01T15:44:34.061Z",
  },
};
